export default __webpack_public_path__ + "static/media/homePage.32da2361.jpg";